import React from 'react';

const ProtectedFooter = () => (
    <div className="">
        
    </div>
)

export default ProtectedFooter;